import angular from 'angular';
import config from '@/config';

angular
  .module('cloudX')
  .controller('ChangeUsernameDialogCtrl', [
    '$element',
    'resourceFactorySvc',
    'flySvc',
    'close',
    '$window',
    '$timeout',
    changeUsernameDialogCtrl,
  ]);

function changeUsernameDialogCtrl($element, resourceFactorySvc, flySvc, close, $window, $timeout) {
  var vm = this;

  vm.data = {
    password: '',
    email: '',
    captcha: '',
    propagate: true,
    captchaAction: 'change_username',
  };

  vm.showCaptcha = function() {
    $window.grecaptcha.enterprise.render('g-recaptcha', {
      sitekey: config.recaptchaKey,
      action: vm.data.captchaAction,
      callback: function(token) {
        $timeout(() => {
          vm.data.captcha = token;
        });
      },
    });
  };

  $timeout(vm.showCaptcha);

  vm.save = function() {
    vm.saving = true;
    resourceFactorySvc.get('user').changeUsername(
      null,
      vm.data,
      function() {
        vm.saving = false;
        flySvc.success('msgEmailChangeUsernameSent');
        close(true, 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
